import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'

const FWStatusIcon: React.FC<FWStatusIconProps> = ({ availableVersion, currentVersion }) => {
    if (availableVersion === currentVersion) return <FontAwesomeIcon icon={faCheck} color="#81E18B" />
    return <FontAwesomeIcon icon={faClock} color="#006EF0" />
}

export type FWStatusIconProps = {
    availableVersion: number
    currentVersion: number
}

export default FWStatusIcon
